import { request } from '@langlois/request';

export async function createEvent ({ commit, dispatch }, { data, competitionId }) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/competition/${competitionId}/event`);

		const response = await request.post(url, data);

		if (response.ok) return await dispatch(`closeForm`);

		const { message } = await response.json();

		if (message) return commit(`vcl/notificationBar/show`, {
			text: message,
			type: `warning`
		}, { root: true });
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while creating the event.`,
			type: `warning`
		}, { root: true });
	}
}
